import { borrarDefaultDropDownOptions } from "../../../common/dataTables/utils";

const dataTableElement = document.getElementById("dataTableModal");

const columns = [
    {
        id: "pedimento_formato",
        name: "Pedimento",
        width: 200,
    },
    {
        id: "material",
        name: "Material",
        width: 250,
    },
    {
        id: "cantidad_descargada",
        name: "Cantidad descargada",
        width: 175,
    },
    {
        id: "cantidad_desperdicio",
        name: "Desperdicio",
        width: 120,
    },
    {
        id: "cantidad_merma",
        name: "Merma",
        width: 120,
    },
    {
        id: "restante",
        name: "Saldo",
        width: 120,
    },
    {
        id: "falta_de_descargar",
        name: "Cantidad pendiente de la descarga",
        width: 250,
    },
];

export const columnsWithDesp = columns.map((item) => ({
    ...dataTableColumnCommonConfiguration,
    ...item,
}));

export const columnsWithoutDesp = columns
    .filter((item) => !["cantidad_desperdicio", "cantidad_merma"].includes(item.id))
    .map((item) => {
        if (item.id === "restante") {
            item.name = "Saldo desperdicio";
            item.width = 170;
        }
        return item;
    })
    .map((item) => ({
        ...dataTableColumnCommonConfiguration,
        ...item,
    }));

export const simulacionDescargaDataTable = new DataTable(dataTableElement, {
    columns: columnsWithDesp,
    inlineFilters: true,
    serialNoColumn: false,
    noDataMessage: "Sin pedimentos de importación seleccionados para descargar",
});

borrarDefaultDropDownOptions(simulacionDescargaDataTable);
